import { TEMPLATE_TYPES } from "features/templates/constants";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogFooter,
  OverlayDialogContent,
  OverlayDialogTitle,
} from "common/components/ui/Dialog";

import EditButton from "./EditButton";
import { useFlowTemplateContext } from "./FlowTemplateContext";

import type { JSX } from "react";

interface MobileLayoutProps {
  actionDelayComponent: JSX.Element;
  templatePreviewComponent: JSX.Element;
  templateEditorComponent: JSX.Element;
  removeButtonComponent: JSX.Element;
  templateSelectComponent: JSX.Element;
}

export default function MobileLayout({
  actionDelayComponent,
  templatePreviewComponent,
  templateEditorComponent,
  removeButtonComponent,
  templateSelectComponent,
}: MobileLayoutProps) {
  const { isEditing, handleSave, handleDiscard, flowTemplate } =
    useFlowTemplateContext();

  return (
    <>
      <div className="flex flex-col gap-2">
        {actionDelayComponent}
        <div className="flex items-center gap-2">
          {templateSelectComponent}
          <EditButton />
        </div>
        {templatePreviewComponent}
        {removeButtonComponent}
      </div>

      <Dialog open={isEditing} onOpenChange={handleDiscard}>
        <OverlayDialogContent>
          <OverlayDialogTitle>
            Edit {TEMPLATE_TYPES[flowTemplate.type].label.toLowerCase()}
          </OverlayDialogTitle>
          <DialogBody className="flex-1">{templateEditorComponent}</DialogBody>
          <DialogFooter className="justify-end">
            <DialogClose asChild>
              <Button variant="outline-black" onClick={handleDiscard}>
                Discard
              </Button>
            </DialogClose>
            <Button onClick={handleSave}>Save</Button>
          </DialogFooter>
        </OverlayDialogContent>
      </Dialog>
    </>
  );
}
